import { render } from "./MagnetScan.vue?vue&type=template&id=e1a62c12&scoped=true&bindings={\"teststring\":\"data\",\"magnetID\":\"data\",\"magnetType\":\"data\",\"url\":\"data\",\"json\":\"data\",\"errored\":\"data\",\"loading\":\"data\",\"exists\":\"data\"}"
import script from "./MagnetScan.vue?vue&type=script&lang=js"
export * from "./MagnetScan.vue?vue&type=script&lang=js"

import "./MagnetScan.vue?vue&type=style&index=0&id=e1a62c12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e1a62c12"

export default script